import { useEffect, useState } from 'react'
import { getImage } from '../lib/db'

export function useImageUrl(imageKey: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    let active = true
    let objectUrl: string | null = null
    if (!imageKey) { setUrl(null); return }
    if (imageKey.startsWith('/api/')) { setUrl(imageKey); return }
    void getImage(imageKey).then((image) => {
      if (!active || !image) return
      objectUrl = URL.createObjectURL(image.blob)
      setUrl(objectUrl)
    })
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl) }
  }, [imageKey])
  return url
}
